import React, { useEffect, useState } from 'react';
import { TabNav } from '../../../components/TabNav';
import { Tab } from '../../../components/Tab';
import { Menu } from '../../../components/Menu';
import { menuListItems } from '../../../assets/menu/menuList';
import { RegistrationData } from './RegistrationData';
import { BussinessTrust } from './BussinessTrust';
import { DepartmentContacts } from './DepartmentContacts';
import { Identity } from './Identity';
import { BaseRoutes } from 'routes/BaseRoutes';
import { useAlert } from 'hooks/useAlert';
import { Contact } from './Contact';

const tabs = ['Dados cadastrais', 'Business Trust', 'Responsáveis', 'Identidade', 'Contato'];

interface SellerDetailsContextProps {
  hasChangedFields: boolean,
  setHasChangedFields: React.Dispatch<React.SetStateAction<boolean>>
}

const DEFAULT_VALUE:SellerDetailsContextProps = {
  hasChangedFields: false,
  setHasChangedFields: () => {}
}

const SellerDetailsContext = React.createContext<SellerDetailsContextProps>(DEFAULT_VALUE);

export const SellerDetails: React.FC = () => {
  const [hasChangedFields, setHasChangedFields] = useState(DEFAULT_VALUE.hasChangedFields);
  const [selected, setSelected] = useState(tabs[0]);
  const [targetSelected, setTagetSelected] = useState<string>(tabs[0]);
  const { alert, setTextAlertInterface, openAlert, closeAlert, caller } = useAlert();

  useEffect(() => {
    if (caller == 'sellerDetails') {
      if (alert.typeContinue === "save") {
        setSelected(targetSelected);
        setHasChangedFields(false);
        closeAlert();
        return;
      }
      if (alert.typeContinue === "discard"){
        closeAlert();
        return;
      }
    }
  }, [alert])

  const handleTabSelected = (event: React.MouseEvent, tab: string) => {
    if (hasChangedFields) {
      setTagetSelected(tab);
      setTextAlertInterface({
        positionCenter: true,
        title: 'Campos atualizados',
        description: 'Alguns campos foram atualizados e as informações serão perdidas. Deseja continuar ou voltar e salvar suas alterações?',
        closeAlertText: 'Voltar',
        continueAlertText: 'Continuar'
      });
      openAlert(true, 'sellerDetails');
    } else {
      setSelected(tab)
    }
  }

  return (
    <Menu links={menuListItems}>
      <TabNav tabs={tabs} selected={selected} onTabSelected={handleTabSelected} backPath={BaseRoutes.sellers}>

        <Tab isSelected={selected} tabName="Dados cadastrais">
          <SellerDetailsContext.Provider value={{
            hasChangedFields,
            setHasChangedFields,
          }}>
            <RegistrationData/>
          </SellerDetailsContext.Provider>
        </Tab>

        <Tab isSelected={selected} tabName="Business Trust">
          <SellerDetailsContext.Provider value={{
            hasChangedFields,
            setHasChangedFields,
          }}>
            <BussinessTrust/>
          </SellerDetailsContext.Provider>
        </Tab>

        <Tab isSelected={selected} tabName="Responsáveis">
          <SellerDetailsContext.Provider value={{
            hasChangedFields,
            setHasChangedFields,
          }}>
            <DepartmentContacts/>
          </SellerDetailsContext.Provider>
        </Tab>

        <Tab isSelected={selected} tabName="Identidade">
          <SellerDetailsContext.Provider value={{
            hasChangedFields,
            setHasChangedFields,
          }}>
            <Identity/>
          </SellerDetailsContext.Provider>
        </Tab>

        <Tab isSelected={selected} tabName="Contato">
          <SellerDetailsContext.Provider value={{
            hasChangedFields,
            setHasChangedFields,
          }}>
            <Contact/>
          </SellerDetailsContext.Provider>
        </Tab>
      </TabNav>
    </Menu>
  )
}

export default SellerDetailsContext;